
import "./src/styles/reset.css";
import React from "react";
import { AppContextProvider } from "./src/context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min"

export const wrapRootElement = ({ element }) => (
  <AppContextProvider>{element}</AppContextProvider>
);
